import "../../styless/pages/home.scss"
import { useEffect} from "react";
import { Link } from "react-router-dom";
import DarkModeButton from "./darkModeButton";
import "../../styless/components/nav.scss"
import LazyLoad from "react-lazyload";

export function removePathName(){
  if(sessionStorage.getItem('pathName')){
    sessionStorage.removeItem('pathName')
  }
}

export default function Nav(){
  
function navLinkAction(){
   //code that is executed after a nav link is pressed
    
   }

return(
        <>
         <LazyLoad>
         <div id="nav" >
         
              <Link to="/" id="home"  onClick={navLinkAction} >
                 
                Home</Link>

              <Link to={"/services"} className="links" onClick={navLinkAction}>Services</Link>

              <Link to={"/demos"} className="links" onClick={navLinkAction}>Demos</Link>
               
              <Link to="/about" className="links" onClick={navLinkAction}>About</Link>

              <DarkModeButton size='22px'/>
              
          </div>
          </LazyLoad>
        </>
    )
}